import { useCallback, useState } from 'react';
import AwaitType from '../../../utils/AwaitType';
import { TCreateAppData } from '../models';
import { createApp } from '../network';

export type TResult = null | AwaitType<ReturnType<typeof createApp>>

export const useAppCreate = (): [
  TResult,
  boolean,
  Error | null,
  (data: TCreateAppData) => void,
] => {
  const [result, setResult] = useState<TResult>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (data: TCreateAppData) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await createApp(data);
      setResult(response);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error('Unknown error'));
      }
    }
    setIsLoading(false);
  }, []);

  return [result, isLoading, error, request];
};
